import React, { Component } from 'react';
import { Form, Icon, Button, Header, Grid } from 'semantic-ui-react';
import { PropTypes } from 'prop-types';
import TagDropdown from 'components/TagDropdown/index';
import IconButton from 'components/IconButtons/index';
import './EditPanel.css';


class EditPanel extends Component {

  render() {
    const props = this.props;
    return (
      // TODO: Make it a button, and onclick change to selection search dropdown
      // highlight matching letters in search in dropdown items ??
      <div className="edit-panel-container">
        {/* Have background be the dark text color */}
        <IconButton
          name="cancel"
          className="edit-panel-cancel-button"
          onClick={props.handleCancel}
        />
        <Form onSubmit={props.handleDone}>
          {/* Center all of the buttons */}
          <Form.Group>
            <Form.Field>
              <label>
                <Header as='h6'>
                  Edit selected entries:
                </Header>
              </label>
              <div className='form-fields-container'>
                <Form.Field className="tag-edit-dropdown-container">
                  {/* Add tag on selection */}
                  {/* Show "Create Tag" if it doesn't exist */}
                  <TagDropdown
                    enableDoneAction={true}
                    handleDone={props.handleDoneEditingTags}
                    // handleTagOptionCreate={props.handleTagOptionCreate}
                    handleTagsUpdated={props.handleTagsUpdated}
                    tagOptions={props.tagOptions}
                    tagsSelected={props.tagsSelected}
                    allowAdditions={true}
                    noResultsMessage={'Type to create new tags...'}
                    handleClose={() => { this.submitButton.focus() }}/>
                </Form.Field>
                {/* Only show mark unread, if some unread, only show read, if some read. */}
                <Button icon labelPosition='left' onClick={props.handleMarkAsUnread}
                  className="mark-unread">
                  <Icon className='flatico-check' />
                  Unread
                </Button>
                <Button icon labelPosition='left' onClick={props.handleMarkAsRead}>
                  <Icon className='flatico-check-2' />
                  Read
                </Button>
                {/* <Button icon='external' onClick={props.handleOpenExternal} /> */}
                <Button
                  color='red'
                  icon
                  className='delete-button'
                  onClick={props.handleEntriesRemove}>
                  <Icon className='flatico-trash' />
                </Button>
                <Button
                  ref={(b) => this.submitButton = b}
                  secondary
                  icon='checkmark'
                  onClick={props.handleDone}
                  type='submit' />
              </div>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

EditPanel.propTypes = {
  tagsSelected: PropTypes.arrayOf(PropTypes.string.isRequired),
  tagOptions: PropTypes.arrayOf(PropTypes.string.isRequired),
  handleDoneEditingTags: PropTypes.func,
  handleTagsUpdated: PropTypes.func,
  handleEntriesRemove: PropTypes.func,
  handleMarkAsRead: PropTypes.func,
  handleMarkAsUnread: PropTypes.func,
  handleDone: PropTypes.func,
  handleCancel: PropTypes.func
}

export default EditPanel;



// WEBPACK FOOTER //
// ./src/components/EditPanel/index.js